import { OnInit, Component } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PershingTranslationService } from '@pershing/pershing-core';
import { DomSanitizer } from '@angular/platform-browser';
import { NxiContextUtils } from '@pershing/nxi-common';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';

declare let dojoApp: any;

@Component({
    selector: 'nmis-qpr-component',
    templateUrl: './NMIS-QPR-component.html'
})

export class NMISQPRComponent implements OnInit {
    appSettings: any;
    challengeURL: string;
    timeStamp: string;
    signedValue: string;
    userRefNum: string;
    acctRef: any;
    inputValue: any;
    launchURL: string;
    subs: Subscription;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private location: Location,
                private translationService: PershingTranslationService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                private sanitizer: DomSanitizer) {
                this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        // Call the wiget params service to get the valid args
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.widgetsParamService(this.acctRef);
        });

    }

    renderDojoWidget(nmisQprParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            nmisQprParams.target = 'qpr';
            nmisQprParams.nmisSSOUrl = this.nxiRestService.serviceUrl + '/sso/websso' + nmisQprParams.nmisSsoURL;
            dojoApp.renderNmisQpr(nmisQprParams);
        }
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyWidget('NMISqprReport');
        }
    }

    widgetsParamService(acctref: any) {
        this.nxiWidgetParamsService.getWidgetParams( acctref , 'nmisQpr').subscribe(
            resp => {
                if (resp.response) {
                    this.renderDojoWidget(resp.response);
                }
            }
        );
    }
    ngAfterViewInit() {
          if (window['require']) {
            let topic = window['require']('dojo/topic');
            topic.subscribe('/nxi/ssoOut/setAccount', acct => {
                document.dispatchEvent(new CustomEvent('portal.gotoview', {
                    detail: {
                        'gotoPage': '/nxi/portfolio/performance',
                        'context': { 'domain': 'account', 'value': acct }
                    }
                }));
            });
    }
    }

}
